import React from 'react';

import {cx} from 'emotion';
import PropTypes from 'prop-types';

import {isNonProdEnvironment} from 'utils/environment';

import styles from './styles.scss';

const propTypes = {
  user: PropTypes.object,
};

/*
 * UserDetailsTestInfo component creates a post-it style message to display a
 * username and all of the collection licenses a user has.
 * This component is only rendered in non-prod environments.
 * It is currently used in the Masthead component and the UtilityNav component.
 */
class UserDetailsTestInfo extends React.Component {
  state = {
    collapsed: true,
  }

  handleClick = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed
    }));
  }

  render() {
    const {user} = this.props;
    const userLicensedCollections = user && user.licensed_collections;
    const userHasLicensedCollections = userLicensedCollections && userLicensedCollections.length > 0;
    const icon = this.state.collapsed ? 'fa-chevron-down' : 'fa-chevron-up';

    if (!isNonProdEnvironment()) {
      return null;
    } else {
      return (
        <div id="userInfoElement">
          {(user && user.is_authenticated) &&
            <button
              tabIndex="-1"
              onClick={this.handleClick}
              data-qa-selector="user_info_toggle_btn"
              className={cx(['btn', styles.testInfoButton, styles.testDetailsRight])}
            >
              <div className={styles.nonProdOnly}>Non-Prod ONLY</div>
              {user && user.username} <i className={`fa ${icon}`} />
            </button>}
          {!this.state.collapsed &&
            <div className={cx(styles.testUserStatus, styles.testDetailsRight)} data-qa-selector="test_user_status">
              <p>User ID: {user.id}</p>
              {(userHasLicensedCollections ?
                <ul className={styles.collectionList}>
                  {userLicensedCollections.map((collection, key) => {
                    return (<li key={key}>{collection.title}</li>);
                  })}

                </ul>
                : <span className={styles.noCollections}>No licensed collections</span>)}

            </div>}
        </div>
      );
    }
  }
}
UserDetailsTestInfo.propTypes = propTypes;
export default UserDetailsTestInfo;
